import { createAsyncThunk, createSlice } from '@reduxjs/toolkit'
import { raiseToast } from '../toast/toast';

import { getSellerPOsRaw } from '../../../api/sellerPO';
import { getPIPunchByBuyerReqIds } from '../../../api/piPunch';
import { getMaterialItemsDataByBuyerReqItemIds } from '../../../api/buyerReqItem';
import { getSearchActiveStatus } from '../../../../utils';


export const fetchSellerPOs = createAsyncThunk('user/getInward', async (params , { dispatch }) => {
    let response 
    if (params?.dataType === "inwardData"){ 
        response = await getSellerPOsRaw(params)
    }
    console.log("Response fetchsellerPOs", response)
    if(response.failure){
        dispatch(raiseToast({severity:'error', detail: response.data.error}))
        throw Error()
    }
    return response
})

export const fetchPIPunch = createAsyncThunk('user/getPIPunch', async (data) => {
    const response = await getPIPunchByBuyerReqIds(data)
    return response
})

export const fetchMaterialsData = createAsyncThunk('user/getMaterials', async (data) => {
    const response = await getMaterialItemsDataByBuyerReqItemIds(data)
    return response.data
})


export const inwardSlice = createSlice({
    name: "user/getInward",
    initialState: {
        loading: false ,
        isInitialLoad: true,
        sellerPOsData: [],
        selectedSellerPO: null,
        piPunchLoading: false,
        piPunchData: {}, 
        materialProductsLoading: false,
        materialProductsData: [],
        paginationParams: {
            pageNo: 0,
            totalRecords: 0,
            recordsPerPage: 10,
            limitedPagination: true,
            getCount: true
        },
        searchParams: {
            dataType: "inwardData",
            searchBy: "all",
            searchText: "",
            dateType: "grnDate",
            excludeDispatchedPOs: true,
        },
        isSmartSearch: true,
        searchOptions: [],
        isSearchVisible: true,
        isSearchActive: true,
        searchConfig: []
    },
    reducers: {
        setInitialLoad: (state, action) => {
            state.isInitialLoad = action.payload
        },
        setSelectedSellerPO: (state, action) => {
            state.selectedSellerPO = action.payload
        },
        updateSearchOptions: (state, action) => {
            state.searchOptions = action.payload
        },
        updateSearchParams: (state, action) => {
            state.searchParams = action.payload
            const parsedState = JSON.parse(JSON.stringify(state))

            const isSearchActive = getSearchActiveStatus(parsedState.searchParams, parsedState.searchConfig)

            state.isSearchActive = isSearchActive
        },
        updateInwardSPOsData: (state, action) => {
            state.sellerPOsData = action.payload
        },
        updateIsSmartSearch: (state, action) => {
            state.isSmartSearch = action.payload
        },
        setIsSearchVisible: (state, action) => {
            state.isSearchVisible = action.payload
        },
        setSearchConfig: (state, action) => {
            state.searchConfig = action.payload
        },
        updateSearchByParam: (state, action) => {
            const parsedState = JSON.parse(JSON.stringify(state))
            const availableOptions = parsedState.searchConfig.map(eachOption => eachOption.name)
            if(availableOptions.includes(action.payload.searchBy)){
                state.searchParams = {...parsedState.searchParams, ...action.payload}
            } else {
                state.searchParams = {...parsedState.searchParams, searchBy: "all", searchText: ""}
            }
        }
    },
    extraReducers : (builder) => {
        builder.addCase(
            fetchSellerPOs.fulfilled, (state, action) => {
                state.loading = false 
                state.sellerPOsData  = action.payload.data.data
                state.paginationParams.pageNo = action.payload.data.pageNo-1
                state.paginationParams.recordsPerPage = action.payload.data.recordsPerPage
                if(action.payload.data.totalRecords || action.payload.data.totalRecords === 0){
                    state.paginationParams.totalRecords = action.payload.data.totalRecords
                    state.paginationParams.excessPagesFound = false
                }
                if(action.payload.data.excessPagesFound || !action.payload.data.excessPagesFound){
                    if(!state.paginationParams.excessPagesFound){
                        state.paginationParams.excessPagesFound = action.payload.data.excessPagesFound
                    }else if(action.payload.data.excessPagesFound === false){
                        state.paginationParams.excessPagesFound = false
                    }
                }
                if(state.sellerPOsData.length){
                    state.isSearchVisible = false
                }
            }
        )
        .addCase(
            fetchSellerPOs.pending, (state, action) => {
                state.loading = true 
            }
        )
        .addCase(
            fetchSellerPOs.rejected, (state, action) => {
                state.loading = false
                state.sellerPOsData = []
                state.paginationParams.totalRecords = 0
            }
        )
        .addCase(
            fetchPIPunch.fulfilled, (state, action) => {
                state.piPunchLoading = false 
                state.piPunchData = action.payload
            }
        )
        .addCase(
            fetchPIPunch.pending, (state, action) => {
                state.piPunchLoading = true 
            }
        )
        .addCase(
            fetchPIPunch.rejected, (state, action) => {
                state.piPunchLoading = false
            }
        )
        .addCase(
            fetchMaterialsData.fulfilled, (state, action) => {
                state.materialProductsLoading = false 
                state.materialProductsData = action.payload
            }
        )
        .addCase(
            fetchMaterialsData.pending, (state, action) => {
                state.materialProductsLoading = true 
            }
        )
        .addCase(
            fetchMaterialsData.rejected, (state, action) => {
                state.materialProductsLoading = false
            }
        )
    }
})

export const { 
    setSelectedSellerPO,
    updateSearchParams, 
    updateSearchOptions, 
    updateInwardSPOsData, 
    setInitialLoad,
    updateIsSmartSearch,
    setIsSearchVisible,
    setSearchConfig
} = inwardSlice.actions

export default inwardSlice.reducer